import { InternalActionKeyId } from '@/define/internal_action_keys'

import lightBrightnessDownSvg from '@/assets/change_key/system/light-brightness-down.svg?raw'
import lightBrightnessUpSvg from '@/assets/change_key/system/light-brightness-up.svg?raw'
import lightSpeedDownSvg from '@/assets/change_key/system/light-speed-down.svg?raw'
import lightSpeedUpSvg from '@/assets/change_key/system/light-speed-up.svg?raw'
import lightEffectModeSvg from '@/assets/change_key/system/light-effect-mode.svg?raw'
import lightColorSwitchSvg from '@/assets/change_key/system/light-color-switch.svg?raw'
import winMacSwitchSvg from '@/assets/change_key/system/win-mac-switch.svg?raw'
import switchWindowsSvg from '@/assets/change_key/system/switch-windows.svg?raw'
import switchMacSvg from '@/assets/change_key/system/switch-mac.svg?raw'
import winKeyLockSvg from '@/assets/change_key/system/win-key-lock.svg?raw'
import lightDirectionSvg from '@/assets/change_key/system/light-direction.svg?raw'
import fn1Svg from '@/assets/change_key/system/fn1.svg?raw'
import fn2Svg from '@/assets/change_key/system/fn2.svg?raw'
import fn3Svg from '@/assets/change_key/system/fn3.svg?raw'
import restoreSvg from '@/assets/change_key/system/restore.svg?raw'
import lightToggleSvg from '@/assets/change_key/system/light-toggle.svg?raw'
import logoLightEffectSvg from '@/assets/change_key/system/logo-light-effect.svg?raw'
import snapTapSvg from '@/assets/change_key/system/snap-tap.svg?raw'
import sideLightBrightnessDownSvg from '@/assets/change_key/system/side-light-brightness-down.svg?raw'
import sideLightBrightnessUpSvg from '@/assets/change_key/system/side-light-brightness-up.svg?raw'
import sideLightSpeedDownSvg from '@/assets/change_key/system/side-light-speed-down.svg?raw'
import sideLightSpeedUpSvg from '@/assets/change_key/system/side-light-speed-up.svg?raw'
import sideLightEffectModeSvg from '@/assets/change_key/system/side-light-effect-mode.svg?raw'
import sideLightColorSwitchSvg from '@/assets/change_key/system/side-light-color-switch.svg?raw'
import sideLightToggleSvg from '@/assets/change_key/system/side-light-toggle.svg?raw'
import sideLightDirectionSvg from '@/assets/change_key/system/side-light-direction.svg?raw'
import sideLightEffectPrevSvg from '@/assets/change_key/system/side-light-effect-prev.svg?raw'
import sideLightEffectNextSvg from '@/assets/change_key/system/side-light-effect-next.svg?raw'
import profile1Svg from '@/assets/change_key/system/profile-1.svg?raw'
import profile2Svg from '@/assets/change_key/system/profile-2.svg?raw'
import profile3Svg from '@/assets/change_key/system/profile-3.svg?raw'
import profile4Svg from '@/assets/change_key/system/profile-4.svg?raw'
import cycleProfilesSvg from '@/assets/change_key/system/cycle-profiles.svg?raw'
import openWebDriverSvg from '@/assets/change_key/system/open-web-driver.svg?raw'
import fallbackSvg from '@/assets/change_key/system/fallback.svg?raw'

const deviceFunctionIcons: Record<number, string> = {
  [InternalActionKeyId.deviceLightBrightnessDown]: lightBrightnessDownSvg,
  [InternalActionKeyId.deviceLightBrightnessUp]: lightBrightnessUpSvg,
  [InternalActionKeyId.deviceLightSpeedDown]: lightSpeedDownSvg,
  [InternalActionKeyId.deviceLightSpeedUp]: lightSpeedUpSvg,
  [InternalActionKeyId.deviceLightEffectMode]: lightEffectModeSvg,
  [InternalActionKeyId.deviceLightColorSwitch]: lightColorSwitchSvg,
  [InternalActionKeyId.deviceWinMacModeSwitch]: winMacSwitchSvg,
  [InternalActionKeyId.deviceSwitchToWindowsMode]: switchWindowsSvg,
  [InternalActionKeyId.deviceSwitchToMacMode]: switchMacSvg,
  [InternalActionKeyId.deviceWinKeyLock]: winKeyLockSvg,
  [InternalActionKeyId.deviceLightDirection]: lightDirectionSvg,
  [InternalActionKeyId.deviceFn1]: fn1Svg,
  [InternalActionKeyId.deviceFn2]: fn2Svg,
  [InternalActionKeyId.deviceFn3]: fn3Svg,
  [InternalActionKeyId.deviceRestore]: restoreSvg,
  [InternalActionKeyId.deviceLightToggle]: lightToggleSvg,
  [InternalActionKeyId.deviceLogoLightEffectMode]: logoLightEffectSvg,
  [InternalActionKeyId.deviceSnapTapToggle]: snapTapSvg,
  [InternalActionKeyId.deviceSideLightBrightnessDown]: sideLightBrightnessDownSvg,
  [InternalActionKeyId.deviceSideLightBrightnessUp]: sideLightBrightnessUpSvg,
  [InternalActionKeyId.deviceSideLightSpeedDown]: sideLightSpeedDownSvg,
  [InternalActionKeyId.deviceSideLightSpeedUp]: sideLightSpeedUpSvg,
  [InternalActionKeyId.deviceSideLightEffectMode]: sideLightEffectModeSvg,
  [InternalActionKeyId.deviceSideLightColorSwitch]: sideLightColorSwitchSvg,
  [InternalActionKeyId.deviceSideLightToggle]: sideLightToggleSvg,
  [InternalActionKeyId.deviceSideLightDirection]: sideLightDirectionSvg,
  [InternalActionKeyId.deviceSideLightEffectPrev]: sideLightEffectPrevSvg,
  [InternalActionKeyId.deviceSideLightEffectNext]: sideLightEffectNextSvg,
  [InternalActionKeyId.deviceSwitchToProfile1]: profile1Svg,
  [InternalActionKeyId.deviceSwitchToProfile2]: profile2Svg,
  [InternalActionKeyId.deviceSwitchToProfile3]: profile3Svg,
  [InternalActionKeyId.deviceSwitchToProfile4]: profile4Svg,
  [InternalActionKeyId.deviceCycleProfiles]: cycleProfilesSvg,
  [InternalActionKeyId.deviceOpenWebDriver]: openWebDriverSvg,
}

export const getDeviceFunctionIconSvg = (id: number): string => deviceFunctionIcons[id] ?? fallbackSvg
